// extracted by mini-css-extract-plugin
module.exports = {"container":"RowList_container__dClW6","withoutSwipper":"RowList_withoutSwipper__DJXqL"};